import FluidContainerComponent from './FluidContainer'
import ContainerComponent from './Container'
import ColComponent from './Col'
import RowComponent from './Row'
import ClearfixComponent from './Clearfix'
import RowBlockComponent from './RowBlock'
import HiddenComponent from './Hidden'
import HelpersStyle from './helpers.module.css'

export const FluidContainer = FluidContainerComponent
export const Container = ContainerComponent
export const Row = RowComponent
export const Clearfix = ClearfixComponent
export const RowBlock = RowBlockComponent
export const Col = ColComponent
export const Hidden = HiddenComponent
export const responsive = HelpersStyle


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Grid/index.js